import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { RegexConstants } from '@wz-constants';
import { QuotationModels } from '@wz-models';
import { AddressApiService, AuthenticationServiceBase } from '@wz-services';
import { getDateUtc } from '@wz-utilities/date.utilities';
import { getControlWithValueChanges } from '@wz-utilities/form.utilities';
import { WzDateValidators } from '@wz-validators';
import { addDays, addYears } from 'date-fns';
import {
  FormGroupBaseComponent,
  getFormGroupBaseDirective,
} from 'libs/modules/tunnelsante-forms/components/form-group-base.component';
import * as _ from 'lodash';
import { HealthModels } from 'models/health.models';
import { PolicyModels } from 'models/policy.models';
import { of } from 'rxjs';
import { startWith, takeUntil, tap } from 'rxjs/operators';
import { AddressModels } from '../../../../../../models/address.models';
import {
  factoryAgeValidators,
  getMinMaxAgeByPackage,
} from '../health-quotation-form/factory-age-validators';
import { Question } from '../health-quotation-formB2C/factory-age-validators';
import POSTAL_CODE = RegexConstants.POSTAL_CODE;
import CityTemplateOptions = AddressModels.CityTemplateOptions;
import HealthAssureForm = HealthModels.HealthAssureForm;
import CitiesRepositoryEnum = AddressModels.CitiesRepositoryEnum;

import moment from 'moment';

@Component({
  selector: 'wz-health-assure-form',
  templateUrl: './health-assure-form.component.html',
  styleUrls: ['./health-assure-form.component.scss'],
  standalone: false,
  providers: [getFormGroupBaseDirective(HealthAssureFormComponent)],
})
export class HealthAssureFormComponent
  extends FormGroupBaseComponent<HealthModels.Assure>
  implements OnInit, OnChanges
{
  controlListeParam!: Question[];
  olderThan80(date: string): any {
    if (date) {
      return moment().diff(moment(date, 'dd/MM/yyyy'), 'years') >= 80;
    }
  }

  @Input() disabled!: boolean;
  @Input() package!: PolicyModels.PackageEnum;
  @Input() formula!: QuotationModels.FormulaEnum;

  @Output() regimeSocial = new EventEmitter<HealthModels.RegimeSocialEnum>();
  @Output() dateEffet: any = new EventEmitter<Date>();

  healthAssureFormModel: HealthAssureForm = {};

  maxAge: number = 85;
  minAge: number | any = null;

  healthEffectDateMin!: Date;

  private _dateEffet!: Date | any;

  override formGroup: FormGroup | any = this.createFormGroup();
  public regimeSocialCtrl!: FormControl;
  public dateEffectCtrl!: FormControl;
  public dateNaissanceCtrl!: FormControl;
  fieldsAdresse: FormlyFieldConfig[] | any = [
    {
      key: 'groupVille',
      fieldGroupClassName: 'form-address__city',
      fieldGroup: [
        {
          key: 'codePostal',
          type: 'input',
          templateOptions: {
            type: 'test',
            label: 'Code postal',
            pattern: POSTAL_CODE,
            required: true,
            minLength: 5,
            maxLength: 5,
            change: (field: any) => {
              let group = this.fieldsAdresse
                .filter((x: any) => x.key == 'groupVille')
                .shift().fieldGroup;
              let cityField = group
                .filter((x: any) => x.key == 'ville')
                .shift();
              let inseeField = group
                .filter((x: any) => x.key == 'inseeCode')
                .shift();
              field.formControl.valueChanges
                .pipe(
                  startWith(field.formControl.value),
                  tap((codePostal: string) => {
                    let citiesList: CityTemplateOptions[];
                    if (codePostal && codePostal.length === 5) {
                      this.addressService
                        .getCities(codePostal, CitiesRepositoryEnum.Smalltox)
                        .subscribe((cities) => {
                          citiesList = cities.map((city) => {
                            let postalCode = _.padStart(
                              city.postalCodes[0],
                              5,
                              '0',
                            );
                            return {
                              label: city.name,
                              value: city.name,
                              codePostal: postalCode,
                              inseeCode: city.inseeCode,
                            };
                          });
                          cityField.templateOptions.options = citiesList.sort(
                            (a, b) =>
                              a.value < b.value
                                ? -1
                                : a.value > b.value
                                  ? 1
                                  : 0,
                          );
                          if (cities.length === 1) {
                            cityField.formControl.patchValue(cities[0].name, {
                              emitEvent: false,
                            });
                            inseeField.formControl.patchValue(
                              cities[0].inseeCode,
                              { emitEvent: false },
                            );
                          } else {
                            cityField.formControl.patchValue('');
                          }
                        });
                    } else if (!codePostal) {
                      cityField.formControl.patchValue('');
                    }
                  }),
                  takeUntil(this.destroy$),
                )
                .subscribe();
            },
          },
          validation: {
            messages: {
              pattern: (_: any, field: FormlyFieldConfig | any) =>
                `"${field.formControl.value}" n'est pas code postal valide`,
            },
          },
        },
        {
          key: 'ville',
          type: 'select',
          templateOptions: {
            label: `Ville`,
            placeholder: 'Choisir la ville',
            required: true,
            options: [],
          },
          hooks: {
            onChanges: (field: any) => {
              let group = this.fieldsAdresse
                .filter((x: any) => x.key == 'groupVille')
                .shift().fieldGroup;
              let codeField = group
                .filter((x: any) => x.key == 'codePostal')
                .shift();
              let inseeField = group
                .filter((x: any) => x.key == 'inseeCode')
                .shift();

              field.formControl.valueChanges
                .pipe(takeUntil(this.destroy$))
                .subscribe((ville: string) => {
                  if (ville) {
                    let options = [];
                    let actualCity: CityTemplateOptions;

                    options.push(field.templateOptions.options);

                    if (options[0].length) {
                      actualCity = options[0].filter(
                        (x: any) => x.value == ville,
                      )[0];
                      codeField.formControl.patchValue(actualCity.codePostal, {
                        emitEvent: false,
                      });
                      inseeField.formControl.patchValue(actualCity.inseeCode, {
                        emitEvent: false,
                      });
                    } else {
                      field.templateOptions.options = of([
                        { value: ville, label: ville },
                      ]);
                    }
                  }
                });
            },
          },
        },
        {
          key: 'inseeCode',
        },
      ],
    },
  ];

  constructor(
    private fb: FormBuilder,
    private addressService: AddressApiService,
    public authService: AuthenticationServiceBase<any, any>,
  ) {
    super();
    this.formGroup = this.createFormGroup();
  }

  ngOnInit(): void {
    this.patchBirthdayValidators();
    this.healthEffectDateMin = this.getHealthEffectDateMin();
  }

  ngOnChanges(changes: SimpleChanges | any) {
    if (
      changes.formula &&
      this.package == PolicyModels.PackageEnum.Sante_Fidelity
    ) {
      this.patchBirthdayValidators(true);
    }
  }

  private createFormGroup() {
    this.dateNaissanceCtrl = this.fb.control('');

    this.regimeSocialCtrl = getControlWithValueChanges(
      this.fb,
      null,
      [Validators.required],
      (fc) => {
        this.regimeSocial.next(fc.value);
      },
      this.destroy$,
    );

    /*
    *  WzDateValidators.min(
        new Date(subYears(getDateUtc(), this.authService.isAdminImpersonated() ? 100 : 85).getFullYear(), 0, 1)
      )
    * */
    this.dateEffectCtrl = getControlWithValueChanges(
      this.fb,
      null,
      [
        Validators.required,
        WzDateValidators.min(this.getHealthEffectDateMin()),
        WzDateValidators.max(addYears(getDateUtc() ?? new Date(), 1)),
      ],
      (fc) => {
        this._dateEffet = null;
        if (fc.value) {
          this._dateEffet = getDateUtc(fc.value);
          this.dateEffet.next(getDateUtc(fc.value));
        } else {
          this.dateEffet.next(null);
        }
        this.patchBirthdayValidators();
        this.dateNaissanceCtrl.updateValueAndValidity();
      },
      this.destroy$,
    );

    const group = this.fb.group({
      dateNaissance: this.dateNaissanceCtrl,
      dateEffet: this.dateEffectCtrl,
      regimeSocial: this.regimeSocialCtrl,
    });

    return group;
  }

  private patchBirthdayValidators(doUpdate?: boolean) {
    const ages = getMinMaxAgeByPackage(this.package, this.formula);
    this.minAge = ages.minAge;
    this.maxAge = ages.maxAge;
    const validators = factoryAgeValidators(
      this._dateEffet,
      ages.minAge,
      ages.maxAge,
    );
    this.dateNaissanceCtrl.setValidators(validators);

    if (doUpdate) {
      this.dateNaissanceCtrl.updateValueAndValidity();
    }
  }

  override onPatchValue(
    _assure: HealthModels.Assure,
    opt: { formula: QuotationModels.FormulaEnum },
  ): any {
    this.formula = opt.formula;
  }

  private getHealthEffectDateMin(): Date {
    if (this.authService.isAdminImpersonated())
      return addDays(getDateUtc() ?? new Date(), -365);
    else {
      const delta = (<any>this.authService.$user).allowDateEffetInPast
        ? -(<any>this.authService.$user).allowDateEffetInPastNbDays + 1
        : 1;
      return addDays(getDateUtc() ?? new Date(), delta);
    }
  }
}
